<template>
  <div v-if="loading">
    <div class="text-center mb-3 justify-content-between">
      <b-spinner variant="primary"></b-spinner>
    </div>
  </div>
  <div v-else class="row">
    <!-- LeftSideBar -->
    <div class="col-lg-9 col-md-7 d-flex flex-column">
      <div class="main-section d-flex flex-column mt-3" style="display: flex">
        <div class="d-flex flex-row mb-2 align-items-start">
          <div class=" me-1" style="font-size: 14px; font-weight: 600;">Slug:</div>
          <div v-if="slugEditEnabled" class="">
            <b-form-input v-model="postDetails.slug" :state="slugValidation()" class="me-3" type="text" v-bind:class="{
    'form-control': true,
    'is-invalid': !slugValidation(),
  }"/>
            <div class="invalid-feedback">
              Slug should not be empty!
            </div>
          </div>
          <div v-else class="me-1 px-1 py-1">
            /{{ postDetails.slug }}
          </div>
          <a v-if="slugEditEnabled == null || slugEditEnabled == false" class="" href="javascript:void(0)"
             style="padding-inline: 5px; padding-block: 1px;" @click="slugEditEnabled = true">
            <i class="fa-regular fa-pen-to-square text-primary"></i> Edit
          </a>
          <a v-else href="javascript:void(0)" style="padding-inline: 5px; padding-block: 1px;"
             @click="slugEditEnabled = false">
            <i class="fa-solid fa-xmark text-primary"></i>
            Cancel</a>
        </div>
        <div class="input-label">Bangla Title <span v-if="banglaValidation" class="text-danger">*</span></div>
        <div class="mb-2">
          <b-form-input v-model="postDetails.title" class="form-control px-3 " placeholder="Add title"
                        style="height: 44px;"
                        v-bind:class="{ 'form-control': true, 'is-invalid': banglaValidation && !isBanglaTitleValid }"
                        v-on:blur="titleBlurred = true"/>
          <div class="invalid-feedback">
            Title should not be empty!
          </div>
        </div>
        <div class="input-label">English Title <span v-if="englishValidation" class="text-danger">*</span></div>
        <b-form-input v-model="postDetails.title_en" class="form-control px-3 " placeholder="Add English title"
                      style="height: 44px;"
                      v-bind:class="{ 'form-control': true, 'is-invalid': englishValidation && !isEnglishTitleValid }"
                      v-on:blur="titleBlurred = true"/>
        <div class="invalid-feedback">
          Title should not be empty!
        </div>
      </div>

      <div class="input-label mt-3">Post Type</div>
      <select v-model="postDetails.view_type" class="form-control" disabled style="height: 44px">
        <option selected="selected" value="REGULAR">REGULAR</option>
        <option value="LIST">LIST</option>
        <option value="FORM">FORM</option>
      </select>

      <div v-if="postDetails.view_type === 'REGULAR'" class="form-group mt-3">
        <!--! add media  -->
        <div class="d-flex justify-content-between">
          <div class="d-flex justify-content-start">
            <button class="btn btn-info btn-lg" @click="showModal = true">Add Media</button>
          </div>
          <div v-if="showModal">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;" tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                            @click="showModal = false"></button>
                  </div>
                  <div class="modal-body">
                    <show-all-media-component/>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                            @click="showModal = false">Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--! Editor -->
        <div class="input-label mt-3">Bangla Content <span v-if="banglaValidation" class="text-danger">*</span></div>
        <Editor :htmlFetch="postDetails.body" @htmlData='getBanglaHtmlContent'></Editor>
        <div class="input-label mt-5">English Content <span v-if="englishValidation" class="text-danger">*</span></div>
        <Editor :htmlFetch="postDetails.body_en" :is-only-english="true" @htmlData='getEnglishHtmlContent'></Editor>
        <!-- publish -->

      </div>

      <div v-else-if="postDetails.view_type === 'LIST'" class="form-group mt-3">
        <div class="input-label">Files</div>
        <b-table :fields="fields" :items="postDetails.element_file_mappings" bordered hover responsive>
          <template #table-busy>
            <div class="text-center text-danger my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(index)="row">
            {{ row.index + 1 }}
          </template>
          <template #cell(title_bn)="row">
            <input v-model="row.item.title_bn" :disabled="row.item.saved" class="form-control mt-2"
                   placeholder="Enter Bangla Title"
                   type="text"/>
          </template>
          <template #cell(title_en)="row">
            <input v-model="row.item.title_en" :disabled="row.item.saved" class="form-control mt-2"
              placeholder="Enter English Title" type="text" />
          </template>
          <template #cell(file_publish_date)="row">
            <VueDatePicker v-model="row.item.file_publish_date" :disabled="row.item.saved" :format="'dd-MM-yyyy'"
              :z-index="9999" teleport="body" auto-apply class="mt-2" />
          </template>
          <template #cell(file)="row">
            {{
              row.item.mediaFileList ?
                  row.item.mediaFileList.map((item) => item["media_file_name"]).join(", ")
                  : ''
            }}
          </template>
          <template #cell(actions)="row">
            <div class="d-flex flex-row gap-2">
              <button class="btn btn-danger"
                      style="width: 35px"
                      @click="deleteOption(row.index)">
                <span class="fa-solid fa-trash"></span>
              </button>
              <button class="btn btn-primary d-flex align-items-center justify-content-center" style="width: 35px"
                      title="Add Attachment" type="button"
                      @click="turnOnFileModal(row.index)">
                <div class="fa-solid fa-plus"></div>
              </button>
            </div>
            <div class="d-flex justify-content-start">
              <div v-if="showModalPartners  && row.index === selectedItemIndexForMedia">
                <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                     class="modal fade show" role="dialog" style="display: block;"
                     tabindex="-1">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                                type="button" @click="showModalPartners = false"></button>
                      </div>
                      <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                        <selectable-media-component
                            :allow-pdf-select="true" :dont-show-image="false"
                            :fetch-image-ids="row.item.mediaFileList ?
                            row.item.mediaFileList.map((item) => item.media_file_id) : []" @imgList="getImages"/>
                      </div>
                      <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        @click="saveImage">Ok</button> -->
                        <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                                @click="showModalPartners = false">Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-table>
        <button class="btn btn-primary" @click="addNewOption">Add File</button>
      </div>
    </div>
    <!-- RightSideBar -->
    <div class="col-lg-3 col-md-5 d-flex flex-row">
      <div class="side-bar d-flex flex-column w-100">
        <div class="publish " style="margin-bottom:4px; background-color:white;">
          <div class="container border">
            <div class="d-flex flex-row mt-3" style="align-items: center;">
              <h5 class="me-auto"><b>Publish</b></h5>
              <div v-if="this.postDetails.active_yn === 'N'">
                <h5>
                  <span class="badge bg-danger">Deleted</span>
                </h5>
              </div>
              <div v-else-if="postDetails.public_yn == 'Y'">
                <h5>
                  <span class="badge bg-success">Published</span>
                </h5>
              </div>
              <div v-else>
                <h5>
                  <span class="badge" style="background-color: indigo;">Draft</span>
                </h5>
              </div>
            </div>

            <hr class="my-2 mx-0"/>

            <!-- Publish time  -->
            <div class="d-flex flex-row my-1">
              <div class="d-flex align-self-center">
                <i class="fa-solid fa-calendar-days icon-publish"></i>
              </div>
              <div class="text-sx align-self-center">Publish:</div>
              <div v-if="postDetails.publish_time == null" class="ms-1 me-auto text-sx align-self-center text-selected"
                   style="">
                immediately
              </div>
              <div v-else class="ms-1 me-auto text-sx align-self-center text-selected" style="">
                {{ postDetails.publish_time_format }}
              </div>
              <button aria-controls="calendarVisibility" aria-expanded="false"
                      class="btn x-small-btn border border-primary text-primary align-self-center mx-1 edit-button"
                      data-bs-toggle="collapse" href="#calendarVisibility" role="button">
                Edit
              </button>
            </div>
            <div id="calendarVisibility" class="collapse">
              <!-- <input type="datetime-local" id="birthdaytime" name="birthdaytime"
                  class="form-control form-control-sm mt-2" v-model="postDetails.publish_time"> -->
              <VueDatePicker v-model="postDetails.publish_time" :format="publishTimeFormat" :format-locale="locale"
                             auto-apply/>
            </div>
            <!-- expiry time  -->
            <div class="d-flex flex-row my-1">
              <div class="d-flex align-self-center">
                <i class="fa-solid fa-calendar-days icon-publish"></i>
              </div>
              <div class="text-sx align-self-center">Expiry:</div>
              <div v-if="postDetails.expiry_time == null" class="ms-1 me-auto text-sx align-self-center text-selected"
                   style="">
                None
              </div>
              <div v-else class="ms-1 me-auto text-sx align-self-center text-selected" style="">
                {{ postDetails.expiry_time_format }}
              </div>
              <button aria-controls="expiryCalendarVisibility" aria-expanded="false"
                      class="btn x-small-btn border border-primary text-primary align-self-center mx-1 edit-button"
                      data-bs-toggle="collapse" href="#expiryCalendarVisibility" role="button">
                Edit
              </button>
            </div>
            <div id="expiryCalendarVisibility" class="collapse">
              <!-- <input type="datetime-local" id="birthdaytime" name="birthdaytime"
                  class="form-control form-control-sm mt-2" v-model="postDetails.expiry_time"> -->
              <VueDatePicker v-model="postDetails.expiry_time" :format="expiryTimeFormat" :format-locale="locale"
                             auto-apply/>
            </div>
            <!--! revision  -->
            <router-link class="mt-3" v-bind:to="'/revision/' + postId">
              <div>
                <span aria-hidden="true">
                  <i class="fa-solid fa-clock-rotate-left"></i>
                  <b>
                    Browse Revisions
                  </b> </span>
              </div>
            </router-link>
            <!--! save  -->
            <hr class="my-2 mx-0"/>
            <div
                v-if="(permissions.UPDATE_CONTENT === 'Y' || permissions.PUBLISH_CONTENT === 'Y') && this.postDetails.active_yn === 'Y'"
                class="d-flex justify-content-between flex-row my-3">
              <button v-if="permissions.UPDATE_CONTENT === 'Y'" class="btn align-self-center"
                      style="background-color: rgb(58, 4, 123); color: white;" @click="submit('N')">
                Save Draft
              </button>
              <button v-if="permissions.PUBLISH_CONTENT === 'Y'" class="btn btn-sm btn-primary"
                      @click="submit('Y')">Update & Publish
              </button>
            </div>
          </div>
        </div>

        <!-- Categories -->
        <div class="categories" style="background-color:white">
          <div class="d-flex flex-column border p-3 h-100">
            <h5><b>Post Categories</b></h5>
            <hr/>
            <div id="myTabContent" class="tab-content ">
              <div id="allCategories" class="tab-pane fade show active">
                <ul class="text-dark" style="list-style-type: none;">
                  <li v-for="(info, index) in categories" :key="index" class="popular-category">
                    <label class="selectit">
                      <input :id="info.name" v-model="postDetails.subCategoryIds" :value="info.id"
                             class="checkbox-input" type="checkbox"/>
                      {{ info.name }}
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <hr class="my-2 mx-0"/>
            <!-- <router-link to="/post/categories" v-if="permissions.UPDATE_CONTENT == 'Y'">
                <div class="btn-sm" role="button">
                    <span aria-hidden="true">+ Add new category</span>
                </div>
            </router-link> -->
          </div>
        </div>
        <!-- designation  -->
        <div v-if="category_id == 8" class="rounded p-3 border mt-3 " style="background-color: white;">
          <div class="main-section d-flex flex-column" style="display: flex">
            <div class="input-label"> Designation <span class="text-danger">*</span></div>
            <b-form-input v-model="postDetails.designation" class="form-control px-3 mb-2" placeholder="Add Designation"
                          style="height: 34px;"/>
            <div class="input-label"> Designation English</div>
            <input v-model="postDetails.designation_en" class="form-control px-3 mb-2"
                   placeholder="Add English Designation" style="height: 34px;" type="text"
                   v-on:blur="generateLinkMethod"/>
            <div class="input-label"> Designation Details <span class="text-danger">*</span></div>
            <b-form-input v-model="postDetails.designation_details
    " class="form-control px-3 mb-2" placeholder="Add Designation" style="height: 34px;"/>
            <div class="input-label"> Designation Details English</div>
            <input v-model="postDetails.designation_details_en" class="form-control px-3 mb-2"
                   placeholder="Add English Designation" style="height: 34px;" type="text"
                   v-on:blur="generateLinkMethod"/>
            <div class="input-label"> Designation Weight <span class="text-danger">*</span></div>
            <input v-model="postDetails.designation_weight" class="form-control px-3 mb-2"
                   placeholder="Add Designation Weight" style="height: 34px;" type="number"/>
          </div>
        </div>
        <!--            meta info-->
        <div class="mt-3">
          <div class=" d-flex flex-column border px-3 pt-3 pb-4 h-100 rounded" style="background-color:white">
            <div class="row align-items-center px-2">
              <div class="col-md-6">
                <h5><b>SEO Info</b></h5>
              </div>
            </div>
            <hr style="height: 0%;"/>
            <div class="main-section d-flex flex-column" style="display: flex">
              <div class="input-label">Meta Title</div>
              <div class="mb-2">
                <b-form-input v-model="postDetails.meta_title" class="form-control px-3 " placeholder="Add Meta Title"
                              style="height: 44px;"/>
              </div>
              <div class="input-label"> Meta Description</div>
              <textarea v-model="postDetails.meta_description" class="form-control px-3 mb-2"
                        placeholder="Add Meta Description" style="height: 44px;" type="text"/>
              <div class="input-label"> Meta Keywords</div>
              <div class="d-flex flex-row" style="align-items: center">
                <input v-model="metaKeyword" class="form-control px-3" placeholder="Add Meta Keywords"
                       style="height: 44px;" type="text" @keyup.enter="addMetaKeyword"/>
                <button class="ms-2 btn btn-sm btn-primary" style="height: 44px;" type="button" @click="addMetaKeyword">
                  Add
                </button>
              </div>
              <div class="d-flex flex-row mt-1 flex-wrap row-gap-1">
                <div v-for="(keyword, index) in metaKeywordsList" :key="index"
                     class="rounded border px-2 py-1 me-1 d-flex flex-row" style="align-items: center;">
                  <div style="font-size: 12px"> {{ keyword }}</div>
                  <div class="btn" style="margin: 0;padding: 1px; " @click="removeKeyword(keyword)">
                    <i class="fa-solid fa-xmark text-danger"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- image  -->
        <div class="my-3 rounded p-3 border" style="background-color: white;">
          <div class="input-label mb-2">Featured Image</div>
          <figure v-if="postDetails.image_id != null" class="figure"
                  style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
            <div v-if="postDetails.image_id != null">
              <img :src="imageBasePath + postDetails.image_url" height="100" width="100">
            </div>
          </figure>
          <div class="d-flex justify-content-start">
            <button class="btn btn-info" style="width: 100%;" @click="showModalLogo = true">Add
              Image
            </button>
          </div>
          <div v-if="showModalLogo">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;" tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title h4">Add Media</h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                            @click="showModalLogo = false"></button>
                  </div>
                  <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                    <select-logo :fetchId="postDetails.image_id" @logoImg="getImageData"/>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-primary" data-bs-dismiss="modal" type="button"
                            @click="showModalLogo = false">Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import postService from '@/services/post.service';
import subcategoryService from "@/services/subCategory.service"
import {notify} from "@kyvg/vue3-notification";
import moment from 'moment';
import Editor from "../../components/Editor";
import showAllMedia from '@/components/Media/ShowAllMedia.vue';
import selectLogo from '@/components/Media/SelectLogo.vue';
import Config from '@/config/index';
import VueDatePicker from '@vuepic/vue-datepicker';
import {format_date_ddmmmyyyy} from "@/helpers";
import {formatInTimeZone} from "date-fns-tz";
import {enUS} from 'date-fns/locale';
import selectableMedia from "@/components/Media/SelectableMedia.vue";


export default {
  name: 'editPost',
  components: {
    "show-all-media-component": showAllMedia,
    "selectable-media-component": selectableMedia,
    Editor,
    "select-logo": selectLogo,
    VueDatePicker,
  },
  props: ['category_id', 'elementIdProp'],
  computed: {
    title() {
      return this.postDetails.title;
    }
  },
  watch: {
    // title() {
    //     this.postDetails.slug = this.postDetails.title.trim().replaceAll('/', '-').replaceAll(' ', '-')
    //         .replace(/[&\\#,+()[/;^!@\]$~%.'":*?<>{}]/g, '').toLocaleLowerCase();
    //     this.postDetails.extension_url = this.postDetails.slug;
    // }
  },
  mounted() {
    this.locale = enUS;
    const eng = localStorage.getItem('english_validation');
    const bang = localStorage.getItem('bangla_validation');
    this.englishValidation = eng === 'Y'
    this.banglaValidation = bang === 'Y'

    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.postId = this.elementIdProp;
    this.imageBasePath = Config.apiFileBasePath;
    this.getCategories();
    this.getPostDetails(this.postId);
  },
  data() {
    return {
      isBanglaTitleValid: true,
      isEnglishTitleValid: true,
      selectedItemIndexForMedia: null,
      loading: false,
      metaKeywordsList: [],
      metaKeyword: null,
      permissions: {},
      englishValidation: false,
      banglaValidation: false,
      titleBlurred: false,
      showModalLogo: false,
      imageBasePath: null,
      postId: null,
      content: null,
      showModal: false,
      categories: [],
      slugEditEnabled: null,
      showModalPartners: false,
      postDetails: {
        public_yn: null,
        base_url: null,
        body: null,
        body_en: null,
        category_id: null,
        expiry_time: null,
        extension_url: null,
        id: null,
        publish_time: null,
        subCategoryIds: null,
        subCategoryNames: null,
        title: null,
        title_en: null,
        element_file_mappings: [],
      },
      requestSaveElement: {
        id: null,
        category_id: null,
        sub_category_ids: [],
        title: "",
        title_en: "",
        base_url: window["baseUrl"],
        extension_url: "",
        body: "",
        body_en: "",
        public_yn: "Y",
        publish_time: null,
        expiry_time: null,
      },
      locale: null,
      fields: [
        {
          key: 'index', label: '#',
          thStyle: {width: "3%"}, tdClass: "px-2", thClass: "px-2",
        },
        {
          key: 'title_bn', label: 'Bangla Title',
          thStyle: {width: "22%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'title_en', label: 'English Title',
          thStyle: {width: "22%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'file_publish_date', label: 'Publish Date',
          thStyle: { width: "22%" }, tdClass: "px-2", thClass: "px-3",
        },
        {
          key: 'file', label: 'File', sortable: false,
          thStyle: {width: "21%"}, tdClass: "px-3 pt-2", thClass: "px-3",
        },
        {
          key: 'actions', label: 'Actions', tdClass: "px-3 pt-2",
          thStyle: {width: "8%"},
        },
      ],
      fileObjects: [
        {
          file_mapping_id: null,
          title_en: "",
          title_bn: "",
          file_publish_date: null,
          saved: false
        },
      ],
    };
  },
  methods: {
    removeKeyword(keyword) {
      if (this.metaKeywordsList.includes(keyword)) {
        const index = this.metaKeywordsList.indexOf(keyword);
        if (index > -1) {
          this.metaKeywordsList.splice(index, 1);
        }
      }
    },
    addNewOption() {
      this.postDetails.element_file_mappings.push({
        option_text: ''
      });
    },
    getImages(data) {
      const parsedData = JSON.parse(data);
      console.log(parsedData)
      this.postDetails.element_file_mappings[this.selectedItemIndexForMedia].mediaFileList = []
      parsedData.forEach((element) => {
        this.postDetails.element_file_mappings[this.selectedItemIndexForMedia].mediaFileList.push(element[0])
      })
    },
    async deleteOption(index) {
      const result = await this.$swal({
        icon: "warning",
        title: "Are you sure?",
        text: "You won't be able to revert this deletion!",
        // title: 'Are you sure, you want to delete the User?',
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#007bff',
        showConfirmButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#dd3333',
      });
      if (result.isConfirmed) {
        this.loading = true;

        try {
          const payload = {
            fileMappingId: this.postDetails.element_file_mappings[index].file_mapping_id
          }
          const response = await postService.deleteFileMapping(payload);
          this.loading = false;
          if (response.data) {
            if (response.data.status) {
              this.postDetails.element_file_mappings.splice(index, 1);
            } else {
              notify({
                type: "error",
                title: "Delete File",
                text: response.data.message,
              });
            }
          } else {
            notify({
              type: "error",
              title: "Delete File",
              text: "Could not delete File",
            });
          }
        } catch (e) {
          this.loading = false;
          console.log(e)
        }
      }

    },
    addMetaKeyword() {
      const keyword = this.metaKeyword;
      if (keyword != null && keyword !== "" && !this.metaKeywordsList.includes(keyword)) {
        this.metaKeywordsList.push(keyword);
      }
      this.metaKeyword = null;
    },
    formatDateDDMMMYYYY(value) {
      return format_date_ddmmmyyyy(value);
    },
    publishTimeFormat(date) {
      const pad = (n) => (n < 10 ? '0' + n : n);

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());

      let hours = date.getHours();
      const minutes = pad(date.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedHours = pad(hours);

      return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
    },
    expiryTimeFormat(date) {
      const pad = (n) => (n < 10 ? '0' + n : n);

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());

      let hours = date.getHours();
      const minutes = pad(date.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedHours = pad(hours);

      return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
    },
    formatter(value) {
      this.postDetails.slug = value.trim().replaceAll('/', '-').replaceAll(' ', '-')
          .replace(/[&\\#,+()[/;^!@\]$~%.'":*?<>{}]/g, '').toLocaleLowerCase();
      this.postDetails.extension_url = this.postDetails.slug;
      return value;
    },
    getBanglaHtmlContent(data) {
      this.postDetails.body = data;
    },
    getEnglishHtmlContent(data) {
      this.postDetails.body_en = data;
    },
    getImageData(data) {
      this.postDetails.image_url = data.file_path;
      this.postDetails.image_id = data.media_file_id;
    },
    async getPostDetails(post_id) {
      try {
        this.loading = true;
        const response = await postService.getPostByElementId(post_id);
        this.loading = false;
        if (response.data) {
          this.postDetails = response.data;
          console.log('this.postDetails.element_file_mappings', this.postDetails.element_file_mappings)
          if (response.data.meta_keywords != null && response.data.meta_keywords !== "") {
            this.metaKeywordsList = response.data.meta_keywords.split(',');
          }
          this.postDetails.publish_time_format = this.formatDateDDMMMYYYY(this.postDetails.publish_time);
          this.postDetails.expiry_time_format = this.formatDateDDMMMYYYY(this.postDetails.expiry_time);
        }
      } catch (error) {
        this.loading = false;
      }
      this.loading = false;
    },
    turnOnFileModal(index) {
      console.log('index', index)
      this.selectedItemIndexForMedia = index;
      this.showModalPartners = true;
    },
    async getCategories() {
      this.loading = true;
      try {
        const response = await subcategoryService.getSubCategoriesByCategoryId(this.category_id);
        this.loading = false;

        if (response.data) {
          this.categories = response.data;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DDThh:mm')
      }
    },
    async submit(public_yn) {
      if (!this.checkValidation()) {
        return;
      }
      // console.log(typeof this.requestSaveElement.publish_time);
      if (this.postDetails.expiry_time && moment(this.postDetails.expiry_time).isBefore(this.postDetails.publish_time)) {
        notify({
          type: "error",
          title: "New Post",
          text: "Expiry time can't be earlier than publish time!",
        });
        return;
      }
      let publish_date;
      if (this.postDetails.publish_time != null && this.postDetails.publish_time !== '') {
        publish_date = formatInTimeZone(new Date(this.postDetails.publish_time), 'Asia/Dhaka', "yyyy-MM-dd'T'HH:mm");
      }

      let expiry_date;
      if (this.postDetails.expiry_time != null && this.postDetails.expiry_time !== '') {
        expiry_date = formatInTimeZone(new Date(this.postDetails.expiry_time), 'Asia/Dhaka', "yyyy-MM-dd'T'HH:mm");
      }
      this.loading = true;
      this.requestSaveElement.category_id = this.category_id;
      this.requestSaveElement.id = this.postId;
      if (public_yn) {
        this.requestSaveElement.public_yn = public_yn;
      }
      this.requestSaveElement.body = this.postDetails.body;
      this.requestSaveElement.slug = this.postDetails.slug;
      this.requestSaveElement.body_en = this.postDetails.body_en;
      this.requestSaveElement.designation = this.postDetails.designation;
      this.requestSaveElement.designation_en = this.postDetails.designation_en;
      this.requestSaveElement.designation_details = this.postDetails.designation_details;
      this.requestSaveElement.designation_details_en = this.postDetails.designation_details_en;
      this.requestSaveElement.designation_weight = this.postDetails.designation_weight;
      this.requestSaveElement.image_id = this.postDetails.image_id;
      this.requestSaveElement.image_url = this.postDetails.image_url;
      this.requestSaveElement.title = this.postDetails.title.trim();
      this.requestSaveElement.title_en = this.postDetails.title_en.trim();
      this.requestSaveElement.sub_category_ids = this.postDetails.subCategoryIds;

      this.requestSaveElement.view_type = this.postDetails.view_type;
      if (this.postDetails.view_type === "LIST") {
        this.requestSaveElement.fileMappingModels = []
        this.postDetails.element_file_mappings.forEach(element_file_mapping => {
          element_file_mapping.media_file_id_list = element_file_mapping.mediaFileList ?
              element_file_mapping.mediaFileList.map((item) => item.media_file_id) : []
          this.requestSaveElement.fileMappingModels.push(element_file_mapping);
        })
      }
      if (this.metaKeywordsList.length !== 0) {
        this.requestSaveElement.meta_keywords = this.metaKeywordsList.toString();
      } else {
        this.requestSaveElement.meta_keywords = null;
      }
      this.requestSaveElement.meta_title = this.postDetails.meta_title;
      this.requestSaveElement.meta_description = this.postDetails.meta_description;
      if (this.postDetails.publish_time != null) {
        this.requestSaveElement.publish_time = publish_date;
      }
      if (this.postDetails.expiry_time != null) {
        this.requestSaveElement.expiry_time = expiry_date;
      }
      try {
        const response = await postService.updatePost(this.requestSaveElement);
        this.loading = false;
        let self = this;
        if (response.data) {
          if (response.data['messageCode'] == 1) {
            notify({
              type: "success",
              title: "Update Post",
              text: response.data.message,
            });
            self.$router.go(-1);
          } else {
            notify({
              type: "error",
              title: "Update Post",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.loading = false;

      }

    },
    titleValidation() {
      this.isBanglaTitleValid = true;
      this.isEnglishTitleValid = true;

      let result = true;
      const banglaRegex = /[\u0980-\u09FF]/;
      const testResult = banglaRegex.test(this.postDetails.title_en);
      if ((this.postDetails.title == null || this.postDetails.title === '') && this.banglaValidation) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Required Bangla title should not be empty!",
        });
        this.isBanglaTitleValid = false;
        result = false;
      } else if ((this.postDetails.title_en == null || this.postDetails.title_en === '') && this.englishValidation) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Required English title should not be empty!",
        });
        this.isEnglishTitleValid = false;
        result = false;
      } else if (testResult) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Remove bangla words in english title!",
        });
        this.isEnglishTitleValid = false;
        result = false;
      } else {
        result = true;
      }

      return result;
    },
    bodyValidation() {
      if (this.postDetails.view_type !== 'LIST') {
        // const banglaRegex = /[\u0980-\u09FF]/;
        // const testResult = banglaRegex.test(this.postDetails.body_en);
        if ((this.postDetails.body == null || this.postDetails.body === "") && this.banglaValidation) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Required Bangla Content should not be empty!",
          });
          return false;
        } else if ((this.postDetails.body_en == null || this.postDetails.body_en === "") && this.englishValidation) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Required English Content should not be empty!",
          });
          return false;
        } 
        // else if (testResult) {
        //   notify({
        //     type: "error",
        //     title: "Wrong Input",
        //     text: "Remove bangla words in english content!",
        //   });
        //   return false;
        // }
         else {
          return true;
        }
      }
      return true;

    },
    slugValidation() {
      return !(this.postDetails.slug == null || this.postDetails.slug.length === 0);
    },
    checkValidation() {
      // if (!this.titleValidation()) {
      //   return false;
      // }
      if (!this.slugValidation()) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Slug should not be empty!",
        });
        return false;
      }
      if (!this.bodyValidation()) {
        return false;
      }
      return true;
    },
  },

}
</script>

<style scoped>
.text-selected {
  font-size: 12px;
  font-weight: 700;
  color: #605e5e;
}

.icon-publish {
  height: 15px;
  width: 15px;
  padding-right: 4px;
  color: #9b9292;

}

.text-radio {
  font-size: 13px;
}

.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 80vh;
  overflow-y: auto;
}

.input-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  margin-left: 2px;
}

.edit-button {
  padding: 2px 10px;
}
</style>